<div class="price-container">
  <div class="content">
    <div class="top-section">
      <h4 class="text-center">Powerful features at a straightforward price.</h4>
      <p class="text-center header-text">Technical talent is already expensive. Technical assessments shouldn't be.</p>
      <div class="list text-center">
        <div>
          <mat-icon color="primary">check_circle_outline</mat-icon> Unlimited candidates
        </div>
        <div>
          <mat-icon color="primary">check_circle_outline</mat-icon> Unlimited assessments
        </div>
        <div>
          <mat-icon color="primary">check_circle_outline</mat-icon> Unlimited user accounts
        </div>
      </div>
    </div>
    <div class="pricing-cards">
      <app-pricing-cards [prices]="prices" (moreClick)="onMoreClick($event)"></app-pricing-cards>
    </div>
  </div>
</div>
